(() => {
  'use strict';

  const current = document.currentScript;
  if (!current) return;

  const urls = {
    splide: current.dataset.splideSrc,
    sections: current.dataset.sectionsSrc,
    search: current.dataset.searchSrc,
    cart: current.dataset.cartSrc,
  };
  const promises = new Map();
  const loaded = new Set();

  const loadScript = (key) => {
    if (promises.has(key)) return promises.get(key);
    const src = urls[key];
    const promise = new Promise((resolve, reject) => {
      if (!src) {
        resolve();
        return;
      }
      const script = document.createElement('script');
      script.src = src;
      script.async = true;
      script.dataset.v4Module = key;
      script.addEventListener('load', () => {
        loaded.add(key);
        resolve();
      }, { once: true });
      script.addEventListener('error', () => reject(new Error(`Unable to load ${key}`)), { once: true });
      document.head.appendChild(script);
    });
    promises.set(key, promise);
    return promise;
  };

  const ensureSections = () => loadScript('splide').then(() => loadScript('sections'));
  const ensureSearch = () => loadScript('search');
  const ensureCart = () => loadScript('cart');

  window.reboundV4Modules = {
    ensureSections,
    ensureSearch,
    ensureCart,
    status: (key) => loaded.has(key),
  };

  const hydrateLazyImage = (image) => {
    image.parentElement?.querySelectorAll('source[data-v4-lazy-srcset]').forEach((source) => {
      source.srcset = source.dataset.v4LazySrcset;
      delete source.dataset.v4LazySrcset;
    });
    if (image.dataset.v4LazySrcset) image.srcset = image.dataset.v4LazySrcset;
    image.src = image.dataset.v4LazySrc;
    delete image.dataset.v4LazySrc;
    delete image.dataset.v4LazySrcset;
  };
  const lazyImages = Array.from(document.querySelectorAll('img[data-v4-lazy-src]'));
  if ('IntersectionObserver' in window) {
    const imageObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        hydrateLazyImage(entry.target);
        imageObserver.unobserve(entry.target);
      });
    }, { rootMargin: '200px 0px' });
    lazyImages.forEach((image) => imageObserver.observe(image));
  } else {
    lazyImages.forEach(hydrateLazyImage);
  }

  const interactionModule = (target) => {
    if (!(target instanceof Element)) return null;
    if (target.closest('#offcanvas-search, [data-bs-target="#offcanvas-search"], [href="#offcanvas-search"]')) {
      return ensureSearch;
    }
    if (target.closest('#offcanvas-cart, [data-bs-target="#offcanvas-cart"], [href="#offcanvas-cart"], [data-cart-action]')) {
      return ensureCart;
    }
    return null;
  };

  document.addEventListener('pointerdown', (event) => {
    interactionModule(event.target)?.().catch(console.error);
  }, { capture: true, passive: true });

  document.addEventListener('focusin', (event) => {
    if (event.target instanceof Element && event.target.closest('#offcanvas-search')) {
      ensureSearch().catch(console.error);
    }
  }, { capture: true });


  const sectionRoots = Array.from(document.querySelectorAll(
    '.testimonials'
  ));

  if ('IntersectionObserver' in window && sectionRoots.length) {
    const observer = new IntersectionObserver((entries) => {
      if (!entries.some((entry) => entry.isIntersecting)) return;
      observer.disconnect();
      ensureSections().catch(console.error);
    }, { rootMargin: '1200px 0px' });
    sectionRoots.forEach((root) => observer.observe(root));
  }

  const idleLoad = () => Promise.allSettled([ensureSearch(), ensureCart(), ensureSections()]);
  window.setTimeout(() => {
    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(idleLoad, { timeout: 5000 });
    } else {
      idleLoad();
    }
  }, 30000);

  document.addEventListener('shopify:section:load', ensureSections);
  document.addEventListener('shopify:section:select', ensureSections);
})();
